import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import { MultiSelect } from "react-multi-select-component";

const AddQRBasis = (props) => {
  const { t } = useTranslation();
  const { showmodal, handleModalClose, handleAddQRBasisModalCloseAfterAPICall } = props;

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [insurerProductList, setInsurerProductList] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    insurer_product_id: "",
    questions_id: [],
  });

  useEffect(() => {
    if (showmodal) {
      QRBasisInsurerProductsList();
      QRBasisQuestionsList();
      setFormData({
        name: "",
        insurer_product_id: "",
        questions_id: [],
      });
    }
  }, [showmodal]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  const QRBasisInsurerProductsList = async () => {
    setLoading(true);
    try {
      const response = await FilePageService.insurer_products_list();
      if (response.data.status) {
        setInsurerProductList(response.data.insurerProductList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const QRBasisQuestionsList = async () => {
    setLoading(true);
    try {
      const response = await FilePageService.qr_basis_questions_list();
      if (response.data.status) {
        setQuestionsList(response.data.questionsList);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuestionsChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      questions_id: selected,
    }));
  };

  const AddQRBasis = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.name || !formData.insurer_product_id || formData.questions_id.length == 0) {
      setFlashMessage({ type: "error", message: t("requriedErrorMessageLabel") });
      return;
    }
    setLoading(true);

    const payload = {
      name: formData.name,
      insurer_product_id: formData.insurer_product_id,
      questions_id: formData.questions_id.map((q) => q.value),
    };

    try {
      const response = await FilePageService.qr_basis_create(payload);
      if (response.data.status) {
        setFlashMessage({
          type: "success",
          message: response.data.message || t("ajouté avec succès"),
        });
        handleAddQRBasisModalCloseAfterAPICall();
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  const questionsOptions =
    questionsList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  return (
    <Fragment>
      <Modal className='missing-doc-modal invalid-doc-modal' show={showmodal} onHide={handleModalClose}>
        <Form onSubmit={AddQRBasis}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter une base QR</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>Ajouter une base QR</h2>

            {flashMessage.message && (
              <div
                className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                  ? "alert-success"
                  : "alert-danger"
                  } text-center`}
                role="alert"
              >
                {flashMessage.message}
              </div>
            )}
            <div className="mt-3">
              <Form.Group className="mb-3">
                <Form.Label>Nom de la base QR</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nom de la base QR"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Produit assureur</Form.Label>
                <Form.Select
                  name="insurer_product_id"
                  value={formData.insurer_product_id}
                  onChange={handleChange}
                >
                  <option value="">sélectionner une option</option>
                  {insurerProductList?.length > 0 ? (
                    insurerProductList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>{t("NorecordsfoundLabel")}</option>
                  )}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Questions</Form.Label>
                <MultiSelect
                  options={questionsOptions}
                  value={formData.questions_id}
                  onChange={handleQuestionsChange}
                  labelledBy="Select questions"
                  overrideStrings={{
                    selectSomeItems: "sélectionner une option",
                    allItemsAreSelected: "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="cancel-btn" variant="primary" onClick={handleModalClose}>
              {t("cancelLabel")}
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              Ajouter
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddQRBasis;
